import { application } from './application.js'

import KycFileBackSelectionMenuController from './file_back_selection_menu_controller.js';
import KycFileFeedbackController from './file_feedback_controller.js';
import PoliticalExpositionController from './political_exposition_controller.js';

application.register('kyc-file-back-selection-menu', KycFileBackSelectionMenuController);
application.register('kyc-file-feedback', KycFileFeedbackController);
application.register('political-exposition', PoliticalExpositionController);
